import { FormSection, Link, Timeline } from '@ksyos/design-system';
import { useSelector } from 'react-redux';
import type { IReduxState } from '@frontend/configureStore';
import { useProcessStartWizardWithCards } from '@frontend/utils/hooks/useProcessStartWizardWithCards';

export function GgzctriageV1FollowingSteps() {
    const hasProcessStartWizardWithCards = useProcessStartWizardWithCards();
    const selectedEmploymentId = useSelector((state: IReduxState) => state.authentication.selectedEmploymentId);

    if (!hasProcessStartWizardWithCards) {
        return null;
    }

    return (
        <FormSection title="Vervolgstappen consult: triage">
            <Timeline>
                <Timeline.Item>
                    De patiënt vult de TeleScreen vragenlijst in en geeft aan op welk moment het telefonische contact
                    met de Ksyos specialist kan plaatsvinden
                </Timeline.Item>
                <Timeline.Item>
                    De Ksyos specialist heeft een telefonisch gesprek (ong. 15 min.) en kijkt of de resultaten van de
                    TeleScreen passen bij het klachtenbeeld van de patiënt
                </Timeline.Item>
                <Timeline.Item>De specialist stelt een advies op</Timeline.Item>
                <Timeline.Item>
                    Je ontvangt het advies in het Ksyos platform en via Edifact in je HIS als je je{' '}
                    <Link
                        openInNewTab={true}
                        to={`/employments/${selectedEmploymentId}/personalSettings`}
                        variant="link"
                    >
                        zorgmailnummer hebt doorgegeven
                    </Link>
                </Timeline.Item>
            </Timeline>
        </FormSection>
    );
}
